var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _g2, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g3, _path17, _g4, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 193,
    viewBox: "0 0 188 193",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.7159 186.931C138.073 186.931 174.031 148.352 174.031 100.762C174.031 53.1717 138.073 14.5923 93.7159 14.5923C49.3589 14.5923 13.4004 53.1717 13.4004 100.762C13.4004 148.352 49.3589 186.931 93.7159 186.931Z",
    fill: "url(#paint0_linear_64_4057)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M137.046 34.6431H48.073C42.5272 34.6431 38.0315 39.4665 38.0315 45.4165H147.087C147.087 39.4665 142.591 34.6431 137.046 34.6431Z",
    fill: "#E0E2EE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0315 45.1221H147.087V134.235C147.087 138.197 145.62 141.996 143.009 144.798C140.398 147.599 136.856 149.173 133.163 149.173H51.9554C48.2625 149.173 44.7209 147.599 42.1097 144.798C39.4985 141.996 38.0315 138.197 38.0315 134.235V45.1221Z",
    fill: "#FBFBFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M128.341 56.3779H56.8127C55.3231 56.3779 54.1155 57.6721 54.1155 59.2686C54.1155 60.8651 55.3231 62.1593 56.8127 62.1593H128.341C129.831 62.1593 131.038 60.8651 131.038 59.2686C131.038 57.6721 129.831 56.3779 128.341 56.3779Z",
    fill: "#D8DBEA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M128.341 80.9404H56.8127C55.3231 80.9404 54.1155 82.2346 54.1155 83.8311C54.1155 85.4276 55.3231 86.7218 56.8127 86.7218H128.341C129.831 86.7218 131.038 85.4276 131.038 83.8311C131.038 82.2346 129.831 80.9404 128.341 80.9404Z",
    fill: "#D8DBEA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M128.341 105.504H56.8127C55.3231 105.504 54.1155 106.798 54.1155 108.395C54.1155 109.991 55.3231 111.285 56.8127 111.285H128.341C129.831 111.285 131.038 109.991 131.038 108.395C131.038 106.798 129.831 105.504 128.341 105.504Z",
    fill: "#D8DBEA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M128.341 130.065H56.8128C55.3232 130.065 54.1156 131.36 54.1156 132.956C54.1156 134.553 55.3232 135.847 56.8128 135.847H128.341C129.831 135.847 131.038 134.553 131.038 132.956C131.038 131.36 129.831 130.065 128.341 130.065Z",
    fill: "#D8DBEA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_64_4057)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.3286 100.235H18.2408C15.1809 100.235 12.7004 102.896 12.7004 106.179V164.587C12.7004 167.87 15.1809 170.532 18.2408 170.532H56.3286C59.3884 170.532 61.8689 167.87 61.8689 164.587V106.179C61.8689 102.896 59.3884 100.235 56.3286 100.235Z",
    fill: "url(#paint1_linear_64_4057)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_64_4057)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.752 9H122.683C120.722 9 119.133 10.705 119.133 12.8083V34.0232C119.133 36.1264 120.722 37.8314 122.683 37.8314H164.752C166.712 37.8314 168.302 36.1264 168.302 34.0232V12.8083C168.302 10.705 166.712 9 164.752 9Z",
    fill: "url(#paint2_linear_64_4057)",
    shapeRendering: "crispEdges"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0782 129.455H22.4907C21.4944 129.455 20.6868 130.321 20.6868 131.39V131.396C20.6868 132.465 21.4944 133.332 22.4907 133.332H52.0782C53.0745 133.332 53.8822 132.465 53.8822 131.396V131.39C53.8822 130.321 53.0745 129.455 52.0782 129.455Z",
    fill: "#D8DBEA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0948 156.736H22.7616C21.7739 156.736 20.9731 157.576 20.9731 158.611V158.617C20.9731 159.653 21.7739 160.493 22.7616 160.493H52.0948C53.0826 160.493 53.8833 159.653 53.8833 158.617V158.611C53.8833 157.576 53.0826 156.736 52.0948 156.736Z",
    fill: "#D8DBEA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0948 142.463H22.7616C21.7739 142.463 20.9731 143.303 20.9731 144.338V144.345C20.9731 145.38 21.7739 146.22 22.7616 146.22H52.0948C53.0826 146.22 53.8833 145.38 53.8833 144.345V144.338C53.8833 143.303 53.0826 142.463 52.0948 142.463Z",
    fill: "#D8DBEA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3089 109.255H24.6627C22.7474 109.255 21.1948 110.921 21.1948 112.975V115.55C21.1948 117.605 22.7474 119.27 24.6627 119.27H33.3089C35.2241 119.27 36.7767 117.605 36.7767 115.55V112.975C36.7767 110.921 35.2241 109.255 33.3089 109.255Z",
    fill: "url(#paint3_linear_64_4057)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M129.516 27.7907C131.77 27.7907 133.597 25.8305 133.597 23.4125C133.597 20.9944 131.77 19.0342 129.516 19.0342C127.262 19.0342 125.435 20.9944 125.435 23.4125C125.435 25.8305 127.262 27.7907 129.516 27.7907Z",
    fill: "#D8DBEA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M144.099 27.7907C146.353 27.7907 148.18 25.8305 148.18 23.4125C148.18 20.9944 146.353 19.0342 144.099 19.0342C141.845 19.0342 140.018 20.9944 140.018 23.4125C140.018 25.8305 141.845 27.7907 144.099 27.7907Z",
    fill: "#D8DBEA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M158.683 27.7907C160.937 27.7907 162.764 25.8305 162.764 23.4125C162.764 20.9944 160.937 19.0342 158.683 19.0342C156.429 19.0342 154.602 20.9944 154.602 23.4125C154.602 25.8305 156.429 27.7907 158.683 27.7907Z",
    fill: "#D8DBEA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M147.618 132.218L137.283 144.442L166.415 172.793L176.75 160.568L147.618 132.218Z",
    fill: "#E0E2EE"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.541 111.984C158.541 137.559 139.217 158.291 115.38 158.291C91.5425 158.291 72.2186 137.559 72.2186 111.984C72.2186 86.4096 91.5425 65.6772 115.38 65.6772C139.217 65.6772 158.541 86.4096 158.541 111.984ZM151.92 111.984C151.92 133.636 135.56 151.188 115.38 151.188C95.1988 151.188 78.839 133.636 78.839 111.984C78.839 90.3321 95.1988 72.7798 115.38 72.7798C135.56 72.7798 151.92 90.3321 151.92 111.984Z",
    fill: "#E0E2EE"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_64_4057)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.38 151.188C135.561 151.188 151.921 133.636 151.921 111.984C151.921 90.3325 135.561 72.7803 115.38 72.7803C95.199 72.7803 78.8392 90.3325 78.8392 111.984C78.8392 133.636 95.199 151.188 115.38 151.188Z",
    fill: "url(#paint4_linear_64_4057)",
    fillOpacity: 0.2
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M121.497 112.638L129.059 105.118C129.767 104.374 130.156 103.385 130.141 102.362C130.126 101.338 129.71 100.361 128.981 99.6373C128.251 98.9135 127.266 98.5005 126.235 98.486C125.204 98.4715 124.207 98.8567 123.458 99.5596L115.879 107.08L108.317 99.5596C107.953 99.1775 107.516 98.8717 107.031 98.6602C106.546 98.4488 106.023 98.336 105.493 98.3285C104.964 98.3211 104.438 98.4191 103.947 98.6169C103.456 98.8146 103.01 99.108 102.635 99.4798C102.261 99.8515 101.965 100.294 101.766 100.781C101.566 101.268 101.468 101.79 101.475 102.316C101.483 102.841 101.596 103.36 101.809 103.842C102.023 104.323 102.331 104.757 102.716 105.118L110.29 112.638L102.716 120.158C102.331 120.519 102.023 120.953 101.809 121.435C101.596 121.916 101.483 122.435 101.475 122.96C101.468 123.486 101.566 124.008 101.766 124.495C101.965 124.982 102.261 125.425 102.635 125.796C103.01 126.168 103.456 126.461 103.947 126.659C104.438 126.857 104.964 126.955 105.493 126.948C106.023 126.94 106.546 126.827 107.031 126.616C107.516 126.404 107.953 126.099 108.317 125.716L115.896 118.196L123.474 125.716C124.231 126.378 125.214 126.728 126.222 126.696C127.23 126.663 128.188 126.251 128.9 125.542C129.612 124.833 130.025 123.882 130.054 122.881C130.084 121.881 129.728 120.907 129.059 120.158L121.497 112.638Z",
    fill: "url(#paint5_linear_64_4057)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_64_4057)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.573,
    cy: 130.08,
    rx: 21.3991,
    ry: 3.03785,
    fill: "#FF7693",
    fillOpacity: 0.56
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M86.281 163.436C86.773 161.249 89.8887 161.249 90.3806 163.436L90.9101 165.789C91.0829 166.557 91.6708 167.164 92.4331 167.362L95.1893 168.075C97.2883 168.619 97.2883 171.6 95.1893 172.143L92.4331 172.857C91.6708 173.054 91.0829 173.662 90.9101 174.43L90.3806 176.783C89.8887 178.969 86.773 178.969 86.281 176.783L85.7516 174.43C85.5787 173.662 84.9908 173.054 84.2285 172.857L81.4724 172.143C79.3733 171.6 79.3733 168.619 81.4724 168.075L84.2285 167.362C84.9908 167.164 85.5787 166.557 85.7516 165.789L86.281 163.436Z",
    fill: "#E0E2EE"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1632 19.1949C28.6552 17.0084 31.7709 17.0084 32.2628 19.1949L32.7923 21.5481C32.9651 22.3163 33.553 22.9234 34.3153 23.1208L37.0715 23.8346C39.1705 24.3783 39.1705 27.3589 37.0715 27.9025L34.3153 28.6163C33.553 28.8138 32.9651 29.4208 32.7923 30.1891L32.2628 32.5423C31.7709 34.7288 28.6552 34.7288 28.1632 32.5423L27.6338 30.1891C27.4609 29.4208 26.873 28.8138 26.1107 28.6163L23.3546 27.9025C21.2555 27.3589 21.2555 24.3783 23.3546 23.8346L26.1107 23.1208C26.873 22.9234 27.4609 22.3163 27.6338 21.5481L28.1632 19.1949Z",
    fill: "#E0E2EE"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.514 17.3189C91.8682 17.3189 92.9659 16.1411 92.9659 14.6882C92.9659 13.2353 91.8682 12.0575 90.514 12.0575C89.1598 12.0575 88.062 13.2353 88.062 14.6882C88.062 16.1411 89.1598 17.3189 90.514 17.3189ZM90.514 19.2919C92.8838 19.2919 94.8049 17.2307 94.8049 14.6882C94.8049 12.1456 92.8838 10.0845 90.514 10.0845C88.1441 10.0845 86.223 12.1456 86.223 14.6882C86.223 17.2307 88.1441 19.2919 90.514 19.2919Z",
    fill: "#E0E2EE"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M166.956 90.5934C166.635 89.2417 167.8 88.0219 169.052 88.3993L173.643 89.7835C174.893 90.1604 175.292 91.8482 174.362 92.8225L170.949 96.3963C170.018 97.3706 168.455 96.9014 168.135 95.5514L166.956 90.5934Z",
    fill: "#E0E2EE"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2301 78.6726C23.4892 78.33 24.62 79.5762 24.2669 80.9174L22.9708 85.8414C22.6172 87.1846 21.0413 87.6155 20.1352 86.6169L16.8086 82.9506C15.9025 81.9519 16.3465 80.2733 17.6074 79.9303L22.2301 78.6726Z",
    fill: "#E0E2EE"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M139.166 169.574C140.426 169.232 141.556 170.478 141.203 171.819L139.907 176.743C139.554 178.086 137.978 178.517 137.072 177.519L133.745 173.852C132.839 172.854 133.283 171.175 134.544 170.832L139.166 169.574Z",
    fill: "#E0E2EE"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.439 55.6328C173.793 55.6328 174.891 54.455 174.891 53.0021C174.891 51.5492 173.793 50.3715 172.439 50.3715C171.085 50.3715 169.987 51.5492 169.987 53.0021C169.987 54.455 171.085 55.6328 172.439 55.6328ZM172.439 57.6058C174.809 57.6058 176.73 55.5447 176.73 53.0021C176.73 50.4596 174.809 48.3984 172.439 48.3984C170.069 48.3984 168.148 50.4596 168.148 53.0021C168.148 55.5447 170.069 57.6058 172.439 57.6058Z",
    fill: "#E0E2EE"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M166.413 172.795L176.748 160.57L178.305 162.085C179.815 163.555 180.72 165.608 180.819 167.794C180.918 169.979 180.204 172.117 178.834 173.737C177.464 175.358 175.55 176.328 173.514 176.435C171.477 176.541 169.484 175.775 167.974 174.305L166.417 172.79L166.413 172.795Z",
    fill: "#E0E2EE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_64_4057",
    x: 0.700439,
    y: 92.2349,
    width: 79.1685,
    height: 100.297,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.104618 0 0 0 0 0.465612 0 0 0 0 0.545833 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_64_4057"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_64_4057",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_64_4057",
    x: 112.133,
    y: 0,
    width: 75.1685,
    height: 54.8315,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.104618 0 0 0 0 0.465612 0 0 0 0 0.545833 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_64_4057"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_64_4057",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_64_4057",
    x: 62.1641,
    y: 56.1051,
    width: 106.432,
    height: 111.758,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 8.33757
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_64_4057"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_64_4057",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_64_4057",
    x: 74.3297,
    y: 106.199,
    width: 84.4859,
    height: 47.7635,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.422,
    result: "effect1_foregroundBlur_64_4057"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_64_4057",
    x1: 93.0968,
    y1: -13.4666,
    x2: 94.9906,
    y2: 289.146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F2F7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F2F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_64_4057",
    x1: 11.2241,
    y1: 152.949,
    x2: 105.547,
    y2: 160.169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8DBEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_64_4057",
    x1: 118.849,
    y1: 29.3808,
    x2: 191.387,
    y2: 29.1779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8DBEA",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_64_4057",
    x1: 47.5815,
    y1: 119.174,
    x2: 19.2228,
    y2: 119.174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.243799,
    stopColor: "#D8DBEA",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8DBEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_64_4057",
    x1: 115.38,
    y1: 72.7803,
    x2: 156.952,
    y2: 173.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8DBEA",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_64_4057",
    x1: 130.323,
    y1: 103.837,
    x2: 92.7018,
    y2: 119.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF62A5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not-found.1b1e3eaf73db635fdc2664e3199da936.svg";
export { ForwardRef as ReactComponent };